import React from "react";

import "../scss/about.scss";
import KakaoMap from "./KakaoMap";

function About() {
  return (
    <div className="about">
      <div className="content">
        <div className="wrap2">
          <h2>브랜딩 전문 기업, <span>코랜</span></h2>
          <div className="bar"></div>

          <p>
            코랜은 홈페이지를 만들 때, 고객사인 발주처의 홈페이지 제작 목적, 활용의 방안을 먼저 여쭈어보고 <br />
            지향해야하는 이상향에 대해 코랜 스스로 연구합니다.
          </p>

          <p>
            홈페이지의 제작목적은 <b>기존고객과 잠재고객의 정보를 모으는 역활</b>이어야 합니다.
          </p>

          <p>
            그들을 위해서 회사가 추구하고자 하는 방향, 상품, 역사등이 잘 축적되어 있어야하고, 홈페이지 방문자들은 <br />
            그것들을 한눈에 일목요연하게 볼 수 있어야 하며, 가능한 빠른 시간내에 소비자의 이목을 끌 수 있어야 합니다.
          </p>
        </div>
      </div>

      <div className="img">
        <img src="/image/subPage/회사소개/회사소개.png" alt="" />
      </div>

      <div className="content">
        <div className="wrap2">
          <h2>브랜딩 전문 기업, <span>코랜</span></h2>
          <div className="bar"></div>

          <p>
            코랜은 브랜드네이밍부터 디자인, 홈페이지 제작, 광고대행까지 <b>올인원 서비스를 제공하는 회사</b>입니다. 그 서비스의 대상자는 코랜 자사의 상품 또는 서비스 일수도 있고, 인근의 식당을 비롯한 가게를 운영하거나 온라인 쇼핑몰을 운영하는 그 어떤 회사일수도 있습니다.
          </p>

          <p>
            십수년간의 온라인 비즈니스 경험을 바탕으로, 등록된 상표, 브랜드가 보다 많은 추종자들이 생길 수 있는 방향을 함께 연구하고, 실행해가겠습니다.
          </p>
        </div>
      </div>

      {KakaoMap(35.831681, 128.6271151, "aboutMap")}

    </div>
  )
}

export default About;